import { useState } from 'react';
import axios from 'axios';
import api from '../api';

const useFileUpload = () => {
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState({});
  
    const upload = async (fileData, url, onUploadProgress) => {
      try {
        const formData = new FormData();
        formData.append('files', fileData);
  
        const response = await axios.post(url, formData, {
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if (onUploadProgress) {
              onUploadProgress(progress);
            }
          },
        });
  
        if (response.status === 200) {
          return response.data; // Returning uploaded file data or status
        }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    };
  
    const handleFileChange = (event) => {
      const selectedFiles = Array.from(event.target.files);
      setFiles([...files, ...selectedFiles]);
    };
  
    const startUpload = async () => {
      const uploadPromises = files.map((file) => {
        return upload(file, `${api()}/filesystemFtp/uploadfileftp`, (progress) => {
          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: progress,
          }));
        });
      });
  
      try {
        const uploaded = await Promise.all(uploadPromises);
        setUploadedFiles([...uploadedFiles, ...uploaded]);
      } catch (error) {
        console.error('Error uploading files:', error);
      }
    };
  
    const resetUpload = () => {
      setFiles([]);
      setUploadedFiles([]);
      setUploadProgress({});
    };
  
    return {
      files,
      uploadedFiles,
      uploadProgress,
      handleFileChange,
      startUpload,
      resetUpload,
    };
};

export default useFileUpload;